import React, { useEffect, useState } from "react";
import {
  CONSENT_EVENT_NAME,
  CONSENT_STATUS_ACCEPTED,
  CONSENT_STATUS_REJECTED,
  CONSENT_STATUS_UNSET,
  getConsentStatus,
  setConsentStatus,
} from "../utils/consent";

function CookieConsentBanner() {
  const [status, setStatus] = useState(getConsentStatus());

  useEffect(() => {
    const handleConsentUpdated = () => {
      setStatus(getConsentStatus());
    };

    window.addEventListener(CONSENT_EVENT_NAME, handleConsentUpdated);
    return () => {
      window.removeEventListener(CONSENT_EVENT_NAME, handleConsentUpdated);
    };
  }, []);

  if (status !== CONSENT_STATUS_UNSET) {
    return null;
  }

  return (
    <aside className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie settings">
      <p className="cookie-banner-copy">
        We use essential site storage to remember your cookie preference and optional analytics cookies to improve SLAM.
      </p>
      <p className="cookie-banner-meta">
        See full details on our <a href="/cookies">Cookies page</a> and <a href="/privacy">Privacy policy</a>.
      </p>
      <div className="cookie-banner-actions">
        <button
          type="button"
          className="cookie-btn cookie-btn-secondary"
          onClick={() => {
            setConsentStatus(CONSENT_STATUS_REJECTED);
            setStatus(CONSENT_STATUS_REJECTED);
          }}
        >
          Reject analytics
        </button>
        <button
          type="button"
          className="cookie-btn cookie-btn-primary"
          onClick={() => {
            setConsentStatus(CONSENT_STATUS_ACCEPTED);
            setStatus(CONSENT_STATUS_ACCEPTED);
          }}
        >
          Accept analytics
        </button>
      </div>
    </aside>
  );
}

export default CookieConsentBanner;